"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.starts-with.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AG_API_KEY, ENV_NAME, GRAPH_SERVICE_API } from '@autoguru/global-configs';
import { i18n } from '@autoguru/i18n';
import { Observable } from 'relay-runtime';
import { relayLogFn } from './environment';
import { emitPartialAuthError } from './partialAuthErrorEvent';
import { createGraphError } from './utils';
export const fetchQuery = ({
  getToken,
  scheme: _scheme = 'Bearer'
} = {}) => (params, variables, _cacheConfig, _uploadables) => Observable.create(sink => {
  const id = params.id || params.cacheID;
  const usePersistedQueryOnly = ENV_NAME === 'preprod' || ENV_NAME === 'prod';
  const postBody = _objectSpread(_objectSpread({
    id
  }, !usePersistedQueryOnly && {
    query: params.text
  }), {}, {
    variables
  });
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': AG_API_KEY,
    'Accept-Language': i18n.language || 'en'
  };
  Promise.resolve().then(async () => {
    let maybeToken = '';
    // biome-ignore lint/suspicious/noAssignInExpressions: migration quick fix. To be fixed when code is touched
    if (maybeToken = await (getToken === null || getToken === void 0 ? void 0 : getToken())) headers['Authorization'] = `${_scheme} ${maybeToken}`;
    const response = await globalThis.fetch(`${GRAPH_SERVICE_API}/graphql`, {
      method: 'POST',
      cache: 'no-cache',
      headers,
      body: JSON.stringify(postBody)
    });
    const responseData = await response.json();
    if (!responseData || Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.errors)) {
      var _responseData$errors$, _responseData$errors;
      const error = createGraphError(responseData === null || responseData === void 0 ? void 0 : responseData.errors);
      if (!(responseData !== null && responseData !== void 0 && responseData.data)) throw error;
      relayLogFn({
        name: 'network.error',
        error,
        networkRequestId: id
      });

      // Filter for AUTH errors and emit event for toast notification
      const authErrors = (_responseData$errors$ = (_responseData$errors = responseData.errors) === null || _responseData$errors === void 0 ? void 0 : _responseData$errors.filter(e => {
        var _e$extensions;
        return (_e$extensions = e.extensions) === null || _e$extensions === void 0 || (_e$extensions = _e$extensions.code) === null || _e$extensions === void 0 ? void 0 : _e$extensions.startsWith('AUTH_');
      })) !== null && _responseData$errors$ !== void 0 ? _responseData$errors$ : [];
      if (authErrors.length > 0) {
        emitPartialAuthError(authErrors);
      }
    }
    sink.next(responseData);
    sink.complete();
  }).catch(error => {
    sink.error(error);
  });
});